import { render } from "./ModeLivraison.vue?vue&type=template&id=4cbd2f34"
import script from "./ModeLivraison.vue?vue&type=script&lang=js"
export * from "./ModeLivraison.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__